import { lazy } from 'react';

const Rdn = lazy(() => import(/* webpackChunkName: "rdn" */ './Rdn'));

export default Rdn;
